// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"CustomDropDownCard_CardContainer__21nMg","Card":"CustomDropDownCard_Card__ZEZhZ","Title":"CustomDropDownCard_Title__3SYhE"};